module.exports = __webpack_public_path__ + "img/442C27_A79E90_847066_8D837C-256px.cdea333f.png";